<template>
    <div class="page-content">
        <div class="page-body">
            <CouponItem :showBuy="false" :item="detail"></CouponItem>
            <div class="page-body-item">
                <div class="content-title">使用说明</div>
                <div class="content-text" v-html="detail.content"></div>
            </div>
            <div class="page-body-item">
                <div class="content-title">购买数量</div>
                <div class="content-text">
                    <el-input-number class="mr-20" v-model="num" :min="0"></el-input-number>
                    付款金额：<span class="color-red f-20 fw-b">{{totalPrice|parseMoney}}</span>
                </div>
            </div>
            <div class="page-body-item">
                <div class="content-title">请选择付款方式</div>
                <PaySelect @change="payTypeChange"></PaySelect>
                <el-button type="primary" @click="couponBuy" :loading="loading">确认支付</el-button>
            </div>
        </div>
        <el-dialog :visible.sync="showWxCode" :close-on-click-modal="false" width="500px">
            <div class="qr-code-content">
                <img :src="codeData" class="qr-code" alt="">
                <div class="f-12 color-grays mt20" style="text-align: center">打开微信'扫一扫',扫描上方二维码</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import CouponItem from "../components/CouponItem";
    import PaySelect from "../components/PaySelect";
    import QRcode from 'qrcode'

    export default {
        name: "couponDetail",
        components: {CouponItem, PaySelect},
        data() {
            return {
                id: '',
                detail: {},
                num: 0,
                payment: '',
                coding: '',
                loading: false,
                showWxCode: false,
                codeData: ''
            }
        },
        created() {
            this.id = this.$route.query.id;
            this.getCoupon()
        },
        computed: {
            totalPrice() {
                if (this.detail.price) {
                    return this.detail.price * this.num
                }
                return 0
            }
        },
        methods: {
            async getCoupon() {
                let [e, data] = await this.$api.getCouponApi({id: this.id})
                this.detail = data.result;
            },
            async couponBuy() {
                if(!this.payment){
                    return this.$message.warning('请选择支付方式')
                }
                this.loading = true;
                let [e, data] = await this.$api.couponBuyApi({
                    id: this.id,
                    num: this.num
                })
                this.loading = false;
                if (data.status) {
                    this.coding = data.result.coding;
                    this.couponPay();
                } else {
                    this.$message.warning(data.msg)
                }
            },
            payTypeChange(e) {
                if (e === 1) {
                    this.payment = 'ali_pc'
                } else if (e === 2) {
                    this.payment = 'wx_pc'
                }
            },
            async couponPay() {
                this.loading = true;
                let [e, data] = await this.$api.couponPayApi({
                    payment: this.payment,
                    coding: this.coding,
                })
                this.loading = false;
                if (data.status) {
                    if (this.payment === 'ali_pc') {
                        this.aliPay(data.result)
                    } else if (this.payment === 'wx_pc') {
                        this.wxPay(data.result)
                    }
                }

            },
            aliPay(params) {
                /*let temp = document.createElement("form");
                temp.action = 'https://openapi.alipay.com/gateway.do?charset=utf-8'
                temp.method = "post";
                temp.target = "_blank";
                temp.style.display = "none";
                let strs = params.split('&');
                for (let v of strs) {
                    let arr = v.split('=');
                    let opt = document.createElement("input");
                    opt.name = arr[0];
                    opt.value = decodeURIComponent(arr[1]);
                    temp.appendChild(opt);
                }
                document.body.appendChild(temp);
                temp.submit();*/
                let a = document.createElement('div');
                a.id = 'appendChild';
                a.hidden = true;
                a.innerHTML = params;
                document.body.appendChild(a);
                document.forms['alipaysubmit'].target = "_blank";
                document.forms['alipaysubmit'].submit();
                setTimeout(()=>{
                    document.body.removeChild(a);
                }, 1000)
            },
            async wxPay(str){
                this.showWxCode = true;
                let res = await QRcode.toDataURL(str);
                this.codeData = res;
            }
        },
    }
</script>

<style scoped lang="less">
    .page-content {
        padding: 20px;

        .page-body {
            width: 900px;
            margin: auto;
            background-color: #ffffff;

            .page-body-item {
                width: 100%;
                padding: 20px;
                box-sizing: border-box;
                border-bottom: 1px solid #e2e2e2;
            }
        }
    }

    .content-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        margin-top: 20px;
        text-align: left;
        box-sizing: border-box;
    }

    .content-text {
        font-size: 14px;
        line-height: 2;
    }
    .qr-code{
        width: 300px;
        height: 300px;
        margin: auto;
    }
    .qr-code-content{
        display: flex;
        justify-content: center;
        align-content: center;
        flex-flow: column;
    }

</style>
